import { render } from "./BlogDetailComponent.vue?vue&type=template&id=2308a52e"
const script = {}

import exportComponent from "/Users/macmini/Sites/self-ship/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__